export interface FetchJsonResult<T> {
    ok: boolean;
    /** HTTP status; 0 quando a requisição nem completou (rede/timeout). */
    status: number;
    data: T | null;
}

/**
 * `fetch` + timeout (AbortSignal) + parse de JSON tolerante, num resultado
 * uniforme. Concentra o padrão try/catch + json().catch que estava repetido
 * no BFF de auth e no proxy.
 */
export async function fetchJson<T>(
    url: string,
    init: RequestInit,
    timeoutMs: number
): Promise<FetchJsonResult<T>> {
    let response: Response;
    try {
        response = await fetch(url, { ...init, signal: AbortSignal.timeout(timeoutMs) });
    } catch {
        return { ok: false, status: 0, data: null };
    }

    const data = (await response.json().catch(() => null)) as T | null;
    return { ok: response.ok, status: response.status, data };
}
